export default function createCalendarPalette(theme, current, base) {
    return {
        calendar: {
            hover: {
                backgroundColor: current[50],
                fromAfter: {
                    backgroundColor: "transparent",
                },
                toAfter: {
                    backgroundColor: "transparent",
                },
            },
            from: {
                backgroundColor: current[50],
            },
            to: {
                backgroundColor: current[50],
            },
            range: {
                backgroundColor: current[50],
            },
            weekday: {
                color: base.gray[600],
            },
            year: {
                borderTopColor: base.gray[200],
                current: {
                    color: current[500],
                },
            },
        },
    };
}
//# sourceMappingURL=calendar.js.map